export default async (categoryId: string = "1", page: number = 1) => {
  const resContents = await useFetchGet<ResponseCardContent>("/contents", {
    params: {
      page: page,
      category: categoryId,
    },
  });
  return resContents;
};
